"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCodesList = exports.splitStates = void 0;
const splitStates = (statesData) => {
    const { regularStates, militaryStates } = statesData.data.elements.reduce((acc, cur) => {
        if (cur.isMilitary === 'true') {
            acc.militaryStates.push(cur.code);
        }
        else {
            acc.regularStates.push(cur.code);
        }
        return acc;
    }, { regularStates: [], militaryStates: [] });
    return { regularStates, militaryStates };
};
exports.splitStates = splitStates;
const getCodesList = (data) => data?.data.elements.map((item) => item.code);
exports.getCodesList = getCodesList;
//# sourceMappingURL=addressModal.helpers.js.map